import { icons, type FeatherAttributes, type FeatherIconNames } from "feather-icons";
import { twMerge } from "tailwind-merge";

export function Icon({
  name,
  className,
  size = 24,
  ...attributes
}: {
  name: FeatherIconNames;
  className?: string | undefined;
  size?: number;
} & Omit<Partial<FeatherAttributes>, "class">) {
  return (
    <div
      className="contents"
      dangerouslySetInnerHTML={{
        __html: icons[name].toSvg({ width: size, height: size, class: twMerge("shrink-0", className), ...attributes }),
      }}
    />
  );
}
